import { useTranslation } from 'react-i18next'

import { JEZICI } from '../i18n'

/**
 * Odabir jezika za površine osoblja (ljuska, prijava, promjena lozinke).
 *
 * Odabrani jezik je uz refresh token jedino što smije u `localStorage` (§13).
 * Gost i vozač imaju svoj (`components/noir`), jer im je podloga tamna i mjera
 * druga — ovaj stoji ondje gdje se radi za stolom.
 */
export function LanguageSwitcher({ tamna = true }: { tamna?: boolean }) {
  const { t, i18n } = useTranslation()

  return (
    <label className="flex items-center gap-2">
      <span className="sr-only">{t('lang.label')}</span>
      <select
        value={i18n.resolvedLanguage}
        onChange={(dogadaj) => void i18n.changeLanguage(dogadaj.target.value)}
        className={
          tamna
            ? 'touch-target rounded-full border border-line bg-transparent px-3 py-1.5 text-xs text-stone hover:border-brass'
            : 'touch-target rounded-lg border border-hair bg-card px-3 py-1.5 text-xs text-ink2'
        }
      >
        {JEZICI.map((jezik) => (
          <option key={jezik} value={jezik} className="text-ink">
            {t(`lang.${jezik}`)}
          </option>
        ))}
      </select>
    </label>
  )
}
